export default {
    user: [],
    notification:{},
    AuthToken:null
  }